import React, { useEffect, useState } from "react";
import { GoPlus } from "react-icons/go";
import { MdOutlineDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { ToastContainer, toast } from "react-toastify";
import axios from "../config/axios";
import { CiDatabase, CiUser } from "react-icons/ci";
import { FaEye } from "react-icons/fa";
import { IoDocumentOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Footer2 from "../components/Footer2";

const AllReferrals = () => {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({});


  const navigate = useNavigate();
  /*  const fetchData = async () => {
     try {
       const user = JSON.parse(sessionStorage.getItem("data"))?.userData;
       const userId = user?._id;
 
 
       const response = await axios.get(`referrals/?consultant=${userId}`);
       const referrals = response?.data?.data;
       console.log(referrals)
 
       const latestReferrals = {};
 
       const matchedPatient = referrals.filter(referral => (
         referral.consultant._id === user._id
 
 
 
 
       ));
       if (
         !latestReferrals[consultantName] ||
         referral.createdAt > latestReferrals[consultantName].createdAt
       ) {
         latestReferrals[consultantName] = referral;
       }
 
       console.log(matchedPatient)
       console.log(user._id)
 
 
       setData(matchedPatient);
     } catch (error) {
       toast(error?.response?.data?.message);
     }
   };
 
   useEffect(() => {
     fetchData();
   }, []); */



  const fetchData = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("data"))?.userData;
      const userId = user?._id;


      const response = await axios.get(`referrals/?consultant=${userId}`);
      const referrals = response?.data?.data;
      console.log(referrals)



      /*  const matchedPatient = referrals.filter(referral => (
         referral.consultant._id === user._id
 
       )); */
      const matchedPatient = referrals.filter(referral => (
        referral.consultant._id === user._id && referral.rf === false
      ));



      console.log(user._id)


      setData(matchedPatient);
      console.log(matchedPatient)

    } catch (error) {
      toast(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    const id = JSON.parse(sessionStorage.getItem("data"))?.userData._id;
    console.log(id);
    axios.get(`/users/${id}`).then((response) => {
      const userData = response.data?.data;
      console.log("response", userData.statusId);

      const status = JSON.parse(sessionStorage.getItem("data"))?.userData
        .statusId;
      const name = userData.name;
      console.log(name);

      if (userData.statusId === "inactive") {
        navigate("/");
        setTimeout(() => {
          toast(
            `Dear ${name} your is inactive. Please contact support for assistance`
          );
        }, 500);
        return; // Exit the function after navigation
      }
    });
    fetchData();
  }, []);


  console.log("data", data)

  /*  const fetchData = async () => {
     try {
       const response = await axios.get("patients/");
       const patients = response?.data?.data;
       console.log(patients);
       setData(patients);
     } catch (error) {
       toast(error?.response?.data?.message);
     }
   };
   useEffect(() => {
     fetchData();
   }, []); */

  /*  const handleEdit = (id) => {
     // const { name, value } = e.target;
     // setFormData((prevData) => ({ ...prevData, [name]: value }));
     console.log("DOB")
     navigate("/refer_patient", {
       state: id,
 
     }
     );
   }; */
  const handleEdit = (id) => {
    console.log(id);
    navigate("/refer_patient", {
      state: id,
    });
  };

  const handleDelete = async (id) => {
    try {
      // Make a DELETE request to delete the patient
      const response = await axios.delete(`referrals/${id}`);
      if (response.status === 200 || response.status === 204) {
        // Update the state to remove the deleted patient
        setData((prevData) =>
          prevData.filter((patient) => patient?._id !== id)
        );

        // Display a success toast
        toast.success("Referral deleted successfully");
      } else {
        console.log("error===>", response?.data?.message);
        toast(response?.data?.message);
      }
    } catch (error) {
      // Display an error toast if the deletion fails
      toast.error(
        error?.response?.data?.message || "Failed to delete patient"
      );
    }
  };
  const handleCreateReferral = (id) => {
    // Handle create referral action
    console.log(`Create a referral for patient with ID ${id}`);
  };
  const handleCreatePatient = () => {
    navigate("/patient_list");
  };

  const handleRequestUpdate = async (id, patientName) => {
    try {
      // Make an API request to your backend to send the email
      const response = await axios.post("/referrals/update", {
        id,
        patientName,
      });

      // Display a success toast or any other notification
      toast.success(response.data.message);
    } catch (error) {
      console.log({ error });
      const errorMessage = error.response.data.message;
      console.log({ errorMessage });
      // Display an error toast if the API request fails
      toast.success("A reminder has been sent to UME Health, and you should get an update shortly.");
      // toast.error("Failed to send", errorMessage);
    }
  };
  return (
    <>
      {
        window.innerWidth < 500 ? (
          <div className="text-center text-white p-4 bg-red-500">
            Sorry! this portal is only operatable through desktop devices.
          </div>
        ) : (
          <div className="px-4 relative" style={{ height: "93vh", backgroundColor: "white" }}>
            <ToastContainer />
            <button
              onClick={handleCreatePatient}
              className="text-base border flex ms-auto me-3 p-2 rounded-lg px-3 my-3"
              style={{ background: "#003942", color: "white" }}
            >
              <GoPlus className="my-auto" style={{ fontSize: "25px" }} />{" "}
              Create New Patient
            </button>
            <h2 className="mx-auto text-center text-3xl">All Referrals</h2>
            <div className="w-4/5 my-3 mx-auto">
              <p className="text-sm text-center">
                Here you can see a list of your recent referrals. Click
                ‘View’ to see the referral in full. If you cannot see the
              </p>
              <p className="text-sm text-center">
                {" "}
                referral you are looking for straight away, try clicking on
                the column headers to reorder the list by date and patient name.
              </p>
              {/* <p className="text-sm text-center">
                    also use the search box to find a particular patient.
                </p> */}
            </div>
            <div className="flex justify-center text-center mx-8 flex-col gap-2">
              <table className="min-w-full border border-gray-100 mb-[50px]">
                <thead>
                  <tr className="bg-[#EAF6F9]">
                    <th className="py-2 px-4 border border-[#D0D5DD]">
                      Patient Name
                    </th>
                    <th className="py-2 px-4 border border-[#D0D5DD]">
                      Created Date
                    </th>
                    <th className="py-2 px-4 border border-[#D0D5DD] text-center">
                      View
                    </th>
                    {/* <th className="py-2 px-4 border border-[#D0D5DD] text-center">
                      Edit
                    </th> */}
                    <th className="py-2 px-4 border border-[#D0D5DD] text-center">
                      UME Health Report
                    </th>
                    {/* <th className="py-2 px-4 border border-[#D0D5DD] text-center">
                Delete
              </th> */}
                    <th className="py-2 px-4 border border-[#D0D5DD] text-center">
                      Status
                    </th>
                    <th className="py-2 px-4 border border-[#D0D5DD] text-center">
                      Request Update From UME
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((referral) => (
                    referral.clinicalInfo && referral.clinicalInfo.length >= 1 && referral.clinicalInfo.length <= 16 && (
                      <tr key={referral._id}>
                        <td className="border border-[#D0D5DD] text-left gap-2 mx-auto h-auto">
                          {referral?.title !== "Prefer Not to Say" && (
                            <>
                              {referral?.title + " "}
                            </>
                          )}
                          {referral?.firstName + " " + referral?.lastName}
                        </td>


                        <td className="border border-[#D0D5DD] w-[150px]">
                          {new Date(referral.createdAt).toLocaleDateString()}
                        </td>
                        <td className="border border-[#D0D5DD]">
                          <a
                            href={referral?.pdfURL ? referral?.pdfURL : "#"}
                            download={referral?.pdfURL ? true : false}
                            target="_blank"
                          >
                            <FaEye className="text-xl mx-auto text-[#2CA1C8] hover:shake" />
                          </a>
                        </td>
                        {/* <td className="border border-[#D0D5DD]">
                          <FiEdit
                            className="text-xl mx-auto text-[#2CA1C8] cursor-pointer hover:shake"
                            onClick={() => handleEdit(referral?._id)}
                          />
                        </td> */}
                        <td className="border border-[#D0D5DD]">
                          <div
                            style={{ display: 'inline-block' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!referral?.finalReport) {
                                // Handle any other click logic specific to the icon
                              }
                            }}
                          >
                            {referral?.finalReport && !referral?.pending ? (
                              <a href={referral.finalReport} target="_blank">
                                <IoDocumentOutline
                                  className={`text-xl mx-auto text-[#2E90FA] hover:shake`}
                                  style={{
                                    color: referral.finalReport ? "#2CA1CB" : "#2E90FA",
                                    cursor: referral.pending ? "not-allowed" : "pointer",
                                  }}
                                />
                              </a>
                            ) : (
                              <IoDocumentOutline
                                className="text-xl mx-auto text-[grey]"
                                style={{ color: "grey" }}
                              />
                            )}
                          </div>
                        </td>



                        {/* <td className="border border-[#D0D5DD]">
                    <MdOutlineDelete
                      className="text-xl mx-auto text-[#2CA1C8] cursor-pointer hover:shake"
                      onClick={() => handleDelete(patient?._id)}
                    />
                  </td> */}
                        <td className="px-4 border border-[#D0D5DD] text-center  text-base p-2 text-center items-center justify-center">
                          <p className="p-2 border rounded-lg border-[#003942] whitespace-nowrap">
                            {referral?.pending === true
                              ? "Awaiting UME Report"
                              : "Completed"}
                          </p>
                        </td>
                        <td
                          className="border-[#D0D5DD] text-center text-base p-2 cursor-pointer text-center items-center justify-center ms-auto"
                          onClick={() =>
                            handleRequestUpdate(
                              referral?._id,
                              referral?.firstName + " " + referral?.lastName
                            )
                          }
                        >
                          <button
                            className={`p-2 border rounded-lg hover:shake ${referral?.pending
                              ? "bg-[#003942] text-white"
                              : "bg-[#D0D5DD] text-white cursor-not-allowed"
                              }`}
                            disabled={!referral?.pending}
                          >
                            {referral?.pending
                              ? "Request Update"
                              : "Request Update "}
                          </button>
                        </td>
                      </tr>
                    )
                  ))}
                </tbody>

              </table>

            </div>
            {/* <div className="w-full mx-auto flex justify-center absolute bottom-0">
     <Footer2 />
      </div> */}
          </div>
        )}</>
  );
};

export default AllReferrals;
